// *******************************************************************************
// Form handling
// *******************************************************************************

const getEmailError = (formElement) =>
  formElement?.querySelector('[type="email"]')?.getAttribute('data-fv-email-address___message') || '';

const handleForm = (form, formAction, id) => {
  const formParent = form.closest('[data-parent]');
  const formAlertError = formParent.querySelector('.form-component__alert-error');
  const emailError = getEmailError(form);

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      email: {
        validators: {
          regexp: {
            regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$',
            message: emailError,
          },
        },
      },
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.radio-button,.dropdown,.counter'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(
          e.element,
          '.mod-input,.checkbox,.radio-button,.dropdown,.counter',
        );
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      grecaptcha.ready(async () => {
        formParent.classList.add('show-loader');
        try {
          const { data } = await onFormSubmit({
            formData: {
              ...getFormValue(form, fv),
              id: localData.id,
              k: form.querySelector('[data-page-k').value,
              lang: localData.lang,
              crmFormId: form.getAttribute('data-crm-form-id'),
              crmFormName: form.getAttribute('data-crm-form-name'),
            },
            recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
            recaptchaAction: formAction,
          });

          // Download PDF file
          if (data.success && data.data.fileUrl) {
            const { fileUrl } = data.data;
            const fileName = data.data.fileName || 'downloaded-file';

            try {
              const response = await fetch(fileUrl);

              if (!response.ok) {
                throw new Error(`Failed to fetch the file. Status: ${response.status}`);
              }

              const blob = await response.blob();
              const downloadUrl = URL.createObjectURL(blob);

              const link = document.createElement('a');
              link.href = downloadUrl;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              URL.revokeObjectURL(downloadUrl);
            } catch (downloadError) {
              console.error('Error downloading file:', downloadError);
            }
          }

          sendToDataLayer(id);

          formParent.classList.remove('show-loader');
          formParent.classList.add('show-thankyou');
          if (formParent.closest('.form-modal')) {
            const formModalEle = formParent.closest('.form-modal');
            formModalEle.classList.add('show-thankyou');
          }
        } catch (error) {
          console.error('Form submission error:', error);
          formParent.classList.remove('show-loader');
          formParent.classList.add('show-error');
          formAlertError.classList.remove('hide');
          formAlertError.innerHTML = error.response?.data?.data?.msg || 'An unexpected error occurred.';
        }
      });
    });
};

const sendToDataLayer = (id) => {
  const idToLabel = {
    'contact-form': 'Contact Form',
    'newsletter-form': 'Newsletter Form',
  };

  // Example usage:
  const label = idToLabel[id] || '';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'generate_lead',
    label,
    form_id: id || '',
  });
};

document.addEventListener('DOMContentLoaded', () => {
  ['newsletter-form', 'newsletter-module-form', 'contact-form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction, id);
    }
  });
});

// Check if all inputGroups in group have same name
const inputGroupParents = document.querySelectorAll('[data-input-group-parent]');

inputGroupParents.forEach((formRow) => {
  const inputGroups = formRow.querySelectorAll('[data-input-group-field]');

  if (inputGroups.length > 1) {
    // Check if failed
    const observer = new MutationObserver(() => {
      const inputParents = formRow.querySelectorAll('[data-input-group-item]');
      const hasFailedRadio = [...inputParents].some((inputParent) =>
        inputParent.classList.contains('is-validation-failed'),
      );
      formRow.classList.toggle('failed', hasFailedRadio);
    });

    inputGroups.forEach((input) =>
      observer.observe(input.closest('[data-input-group-item]'), { attributes: true, attributeFilter: ['class'] }),
    );

    // Get the first error message and create a new div
    if (formRow.classList.contains('input-group')) {
      const errorMessage = formRow.querySelector('[data-fv-not-empty___message]');
      if (errorMessage) {
        const groupErrorMessage = document.createElement('div');
        groupErrorMessage.classList.add('fv-plugins-message-container', 'group-error');
        groupErrorMessage.innerHTML = errorMessage.getAttribute('data-fv-not-empty___message');

        formRow.appendChild(groupErrorMessage);
      }
    }
  }
});

attachEvent('.form-component__accordion-title', 'click', (btn) => {
  const parent = btn.target.closest('.form-component__accordion');
  const accordionContent = parent.querySelector('.form-component__accordion-content');
  slideToggle(accordionContent, 300, 'block');
});

attachEvent('.form-component__submit button', 'click', (ev) => {
  ev.target.classList.add('is-disabled');

  setTimeout(() => {
    ev.target.classList.remove('is-disabled');
  }, 2000);
});

const applyInputFilter = (selector, regex, replace) => {
  document.querySelectorAll(selector).forEach((input) => {
    input.addEventListener('input', () => {
      input.value = input.value.replace(regex, replace);
    });
  });
};

applyInputFilter('input[name="first_name"], input[name="last_name"]', /[^\p{L}\s'-]/gu, '');

const numbersFields = document.querySelectorAll('[data-telephone]');

numbersFields.forEach((input) => {
  input.addEventListener('input', (event) => {
    const inputValue = event.target.value;
    event.target.value = inputValue.replace(/(?!^\+)\D/g, '');
  });
});
